export default {

  error: {
    duplicateRegCode: 'Selline registrikood on andmebaasis olemas',
    creditExceedsInvoice: 'Krediitarve ületab algse arve summat'
  },

  validation: {
    messages: {
      required: 'Kohustuslik väli',
      numeric: 'Sisesta täisarv',
      decimal: 'Sisesta arv',
      min: 'Liiga lühikene',
      email: 'E-mail ei ole korrektne',
      min_value: 'Liiga väike',
      max_value: 'Liiga suur',
      minDays: 'Liiga palju minevikus',
      maxDays: 'Liiga palju tulevikus',
      max: 'Sisestatud tekst on liiga pikk',
      _default: 'Sisestatud väärtus ei ole korrektne'
    }
  },

  MID: {
    SERVICE_ERROR: 'Mobiil-ID tehniline viga',
    USER_PHONE_ERROR: 'Kasutajaga telefoniga seotud üldine viga',
    NO_AGREEMENT: 'Kasutajal pole Mobiil-ID lepingut',
    CERTIFICATE_REVOKED: 'Kasutajal pole Mobiil-ID lepingut',
    NOT_VALID: 'Toiming on lõppenud, kuid kasutaja poolt tekitatud signatuur ei ole kehtiv',
    EXPIRED_TRANSACTION: 'Mobiil-ID sessioon on aegunud',
    USER_CANCEL: 'Kasutaja katkestas',
    PHONE_ABSENT: 'Telefon ei ole levis',
    SENDING_ERROR: 'Muu sõnumi saatmise viga (telefon ei suuda sõnumit vastu võtta, sõnumikeskus häiritud)',
    INTERNAL_ERROR: 'Mobiil-ID Teenuse tehniline viga',
  },

  TOLL_REPORT: {
    TAX_NOT_FOUND: 'Maksu ei leitud',
    DECLARATION_NOT_FOUND: 'Deklaratsooni ei leitud',
    SETTLED: 'OK',
    NO_INVOICE: 'Arve puudub'
  }
}
